import { render, staticRenderFns } from "./testiCarrelloProdotti.vue?vue&type=template&id=141357a4&"
import script from "./testiCarrelloProdotti.vue.ts?vue&type=script&lang=ts&"
export * from "./testiCarrelloProdotti.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports